import Spinner from '../../assets/Loader.svg';
import './Loader.scss';

interface Props {
    loading: boolean;
}

function Loader(props: Props) {
    const { loading } = props;

    if (!loading) return null;
    return (
        <div className='loader-container'>
            <div className='loader'>
                <img src={Spinner} alt='spinner' />
            </div>
        </div>
    )
}

export default Loader;
